import { cloneDeep } from 'lodash/lang'

import {
  SET_PAYMENT_PROFILE_FORM,
  SET_PAYMENT_METHOD
} from 'actions/account/checkout/actionTypes'

const reducer = (state = {}, action) => {
  switch (action.type) {
    case SET_PAYMENT_PROFILE_FORM:
      return cloneDeep(action.paymentProfile)
    case SET_PAYMENT_METHOD:
      return Object.assign({}, state, { paymentMethod: action.paymentMethod })
    default:
      return state
  }
}

export default reducer
